import { usePage } from '@inertiajs/react'
import { Network } from 'lucide-react'
import type { SharedProps } from '@/frontend/types/inertia'
import NavItem from '@/frontend/layouts/LegacyNavItem'
import DashboardSidebarLink from '@/frontend/features/DashboardRuntime/SidebarLink'

export default function LegacyForgeNavigation({ onNavigate, expanded, mobile }: { onNavigate: () => void; expanded: boolean; mobile: boolean }) {
  const { props, url } = usePage<SharedProps>()
  const projectId = url.split('?')[0].match(/^\/dashboard\/projects\/([^/]+)\/dashboards(?:\/|$)/)?.[1]
    || new URLSearchParams(url.split('?')[1] ?? '').get('project_id') || props.forgeAccess?.default_project_id
  const href = projectId ? `/dashboard/discovery?project_id=${encodeURIComponent(projectId)}` : '/dashboard/discovery'
  return <>
    <NavItem href={href} alsoMatchPaths={['/dashboard/discovery', ...(projectId ? [`/dashboard/projects/${projectId}/dashboards`] : [])]}
      icon={<Network className="h-4 w-4 flex-shrink-0" strokeWidth={1.75} />}
      label={props.navigationLabels.discovery} onClick={onNavigate} shouldShowExpanded={expanded} isMobileMenuOpen={mobile} />
    {projectId && <li className={expanded || mobile ? 'ml-7 border-l border-border pl-2' : ''}>
      <DashboardSidebarLink onNavigate={onNavigate} compact={!expanded && !mobile} />
    </li>}
  </>
}
